export default "__VITE_ASSET__DaFPKjuQ__"